<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Messages by Time') }}</v-card-title>

        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="activeuserbytimeSeries">
          <apexchart
            ref="activeuserbytime"
            :key="chartKey"
            type="area"
            height="350"
            :options="activeuserbytime"
            :series="activeuserbytimeSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { PAGE } from '@/constants/page.js'
import moment from 'moment'

import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './../DashboardGraphLoading'
export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  props: ['loading', 'selectedDate', 'filter', 'com7pageid', 'filterUser', 'filterTcpPage'],
  data: function () {
    return {
      activeuserbytimeSeries: undefined,

      activeuserbytime: {
        starttime: 0,
        endtime: 24,
        chart: {
          height: 350,
          type: 'area',
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        xaxis: {
          categories: [
            '0:00',
            '1:00',
            '2:00',
            '3:00',
            '4:00',
            '5:00',
            '6:00',
            '7:00',
            '8:00',
            '9:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00'
          ]
        },
        yaxis: {
          show: true,
          title: {
            text: this.$t('Message')
          }
        },
        tooltip: {
          x: {
            format: 'HH:mm'
          }
        }
      },
      chartKey: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function () {
        this.getActiveUserByTime()
      },
      deep: true
    },
    filter: function () {
      this.getActiveUserByTime()
    },
    filterUser: function () {
      this.getActiveUserByTime()
    },
    filterTcpPage: function () {
      this.getActiveUserByTime()
    }
  },
  mounted: function () {
    this.initData()
  },
  methods: {
    initData() {
      this.getActiveUserByTime()
    },
    getActiveUserByTime: function () {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid,
        datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        time_0: vm.activeuserbytime.starttime,
        time_1: vm.activeuserbytime.endtime
      }

      if (vm.filter !== 'all') {
        Object.assign(data, { app: vm.filter })
      }

      if (vm.isTcpMainPage) {
        data.pageid = vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
        Object.assign(data, {
          tcp_master_page_id: vm.selectedBot.pageid
        })
      }

      vm.$emit('onLoaded', { loading: true, data: null })
      let selectedApi = 'getDashboardActiveUserByTime'
      if (vm.$store.state.selectedBot.theme == 'ticket2') {
        selectedApi = 'getcom7pagereport_activeusers_bytime'
        data.pageid = vm.com7pageid ? vm.com7pageid : vm.$store.state.selectedBot.pageid
      }

      if (vm.selectedBot && vm.selectedBot.type === 'mtc') {
        if (vm.filterUser && vm.filterUser.value !== 'all') {
          Object.assign(data, { filter: vm.filterUser.value })
        }
      }

      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$emit('onLoaded', { loading: false, data: null })
          return
        }
        let data = []
        let label = []
        let max = 0
        if (response.data.length > 0) {
          for (const index in response.data[0]) {
            if (response.data[0].hasOwnProperty.call(response.data[0], index)) {
              const val = response.data[0][index]
              label.push(index.split('_')[1] + ':00')
              data.push(parseInt(val))

              if (max < parseInt(val)) {
                max = parseInt(val)
              }
            }
          }

          vm.activeuserbytime.raw = data
        }

        vm.activeuserbytimeSeries = [{ name: vm.$t('Message'), data: data }]

        // vm.activeuserbytime.xaxis.categories = label;
        vm.$nextTick(function () {
          if (vm.$refs.activeuserbytime) {
            vm.$refs.activeuserbytime.updateOptions({
              yaxis: {
                max: max + 5
              },
              xaxis: {
                categories: label,
                labels: {
                  show: true
                }
              }
            })
          }
          vm.$emit('onLoaded', { loading: false, data: vm.activeuserbytimeSeries })
        })
        vm.chartKey++
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/active-user/ActiveUserByTime.vue